module.exports = __webpack_public_path__ + "img/gh.4410ce35.svg";